module.exports = __webpack_public_path__ + "cancellara-dist/img/map-small.d3b569d3.jpg";